import { useEffect, useState } from "react";

import { Centered } from "./Centered";
import { sshGatewayUrl, isSSHPortalOrigin, hasSSHOrigin } from "./constants";
import { queryUserName } from "./queryUserName";
import { SymContextProvider } from "./SymContext";

import type { PropsWithChildren } from "react";

export const SymAuthGate = ({ children }: PropsWithChildren) => {
  const [username, setUsername] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState("");

  useEffect(() => {
    const onMessage = async (event: MessageEvent) => {
      if (
        event &&
        isSSHPortalOrigin(event.origin) &&
        typeof event.data === "string" &&
        event.data.startsWith("whiteboard-set-user-token:")
      ) {
        setLoading(true);
        const token = event.data.substring("whiteboard-set-user-token:".length);
        setToken(token);
        queryUserName(token)
          .then((username) => {
            setUsername(username);
            setLoading(false);
            setIsAuthenticated(true);
          })
          .catch((error) => {
            console.error(error);
            setLoading(false);
            setIsAuthenticated(false);
          });
      }
    };

    if (hasSSHOrigin && sshGatewayUrl) {
      window.addEventListener("message", onMessage);
    }

    window.parent.postMessage("whiteboard-get-user-token", "*");

    return () => {
      if (hasSSHOrigin && sshGatewayUrl) {
        window.removeEventListener("message", onMessage);
      }
    };
  }, []);

  if (!hasSSHOrigin || !sshGatewayUrl) {
    return <Centered>Missing configuration!</Centered>;
  }

  if (loading) {
    return <Centered>Loading...</Centered>;
  }

  if (!isAuthenticated) {
    return <Centered>Authenticating...</Centered>;
  }

  return (
    <SymContextProvider value={{ username, token }}>
      {children}
    </SymContextProvider>
  );
};
